import { HttpParams } from '@angular/common/http';
import { Inject, Injectable, LOCALE_ID } from '@angular/core';
import { ActivatedRouteSnapshot, Params, Router } from '@angular/router';
import { WipperozAlertService } from 'app/wipperoz-core/services/alert.service';
import { LoggingService } from 'app/wipperoz-core/services/logging.service';
import { WipperozApiService } from 'app/wipperoz-core/services/wipperoz-api.service';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { filter } from 'rxjs/operators';

import { ServicingContent } from './types/servicing-content.model';

export class LastEvaluatedKey {
  CreatedOn: number;
  Pkey: string;
  Skey: string;
}

@Injectable({
  providedIn: 'root'
})
export class ServicingService {
  onResultsChanged: BehaviorSubject<any>;

  routeParams: Params;
  content: ServicingContent[] = [];
  lastKey: LastEvaluatedKey;

  constructor(
    private _wipperozApiService: WipperozApiService,
    private wipperozAlertService: WipperozAlertService,
    private loggingService: LoggingService,
    private router: Router,

    @Inject(LOCALE_ID) private localeId: string
  ) {
    this.onResultsChanged = new BehaviorSubject<any>(null);
  }

  resolve(route: ActivatedRouteSnapshot): Observable<any> | Promise<any> | any {
    this.routeParams = route.params;
    return new Promise((resolve, reject) => {
      this.getServicingContentBySlug().then((data) => {
        resolve({ servicingContent: data, source: 'servicing' });
      }, reject);
    });
  }

  getServicingContentBySlug(): Promise<any> {
    const id = this.routeParams !== undefined ? this.routeParams.id : 0;
    let params = new HttpParams();

    params = params.append('language', this.localeId);
    params = params.append('slug', id);
    if (this.localeId === '' || id === '') {
      return new Promise((resolve, reject) => {
        this.router.navigate(['/']);
        return reject;
      });
    }
    return new Promise((resolve, reject) => {
      this._wipperozApiService
        .get('/resources/servicing-content-by-slug', params)
        .pipe(filter((response: any) => response !== undefined))
        .subscribe(
          (response: any) => {
            this.content = response;
            resolve(response);
          },
          (err) => {
            if (err.error.errorType === 'IncorrectSlug' || err.error.errorType === 'MissingConfiguration') {
              this.router.navigate(['/']);
            } else {
              this.loggingService.logError('servicing.service: getServicingContent error', JSON.stringify(err));
              this.wipperozAlertService.error(
                $localize`:@@errorGettingServicingContentMessage:Error getting servicing content. We are investigating the cause.`,
                false,
                10000
              );
            }
          }
        ),
        (err) => {
          of(`I caught: ${err}`);
          return reject;
        };
    });
  }
}
